const getManufacturerPortalName = (manufacturer: string): string => {
    if (manufacturer === 'Victron') {
        return 'VRM';
    } else if (manufacturer === 'SMA') {
        return 'SMA Portal';
    }
    return manufacturer;
}

const doesManufacturerRequireManualAuth = (manufacturer: string): boolean => {
    if (manufacturer === 'Victron') {
        return true;
    }
    return false;
}

export { getManufacturerPortalName, doesManufacturerRequireManualAuth };